export default class Listener {
   /** Добавляет коллбек на событие загрузки всех ресурсов страницы */
   static onLoad = (callback) => addEventListener('load', callback)
   /** Добавляет коллбек на событие загрузки DOM */
   static onLoadDOM = (callback) => addEventListener('DOMContentLoaded', callback)

   static onScroll = (callback) => addEventListener('scroll', callback)

   static onClick = (element, callback) => element?.addEventListener('click', callback)
   static onClickSelector = (selector, callback) => Listener.onClick(document.querySelector(selector), callback)
   /** Добавить всем элементам обработчик клика */
   static onClickAll = (selector, callback) => document.querySelectorAll(selector).forEach(item => Listener.onClick(item, callback))

   static onSubmit = (element, callback) => element.addEventListener('submit', callback)
   static onSubmitSelector = (selector, callback) => Listener.onSubmit(document.querySelector(selector), callback)
}